import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';

@Component({
  selector: 'app-signup-logout-modal',
  templateUrl: './signup-logout-modal.component.html',
  styleUrls: ['./signup-logout-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignupLogoutModalComponent {
  readonly showModal = input<boolean>(false);
  readonly handleLogout = output<void>();

  onConfirm() {
    this.handleLogout.emit();
  }
}
